import React from 'react'

import { BasicComponent } from '../../types/BaseComponents'
import { getClassNames } from '../utils/ClassNameUtils'
import styles from './index.module.scss'

export interface TextProps extends BasicComponent {
  size?: '8' | '10' | '12' | '14' | '18' | '24'
  underline?: boolean
  italic?: boolean
  children: React.ReactNode
  weight?: 'regular' | 'bold' | 'semibold' | 'light'
  tag?: 'p' | 'label' | 'a' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'strong'
  color?: 'black-main' | 'black-3' | 'blue-main' | 'white'
  fontFamily?: 'proxima'
}

const Text: React.FC<TextProps> = ({
  tag = 'p',
  size = '14',
  underline = false,
  italic = false,
  weight = 'regular',
  color = 'black-main',
  fontFamily = 'proxima',
  children,
  ...rest
}: TextProps) => {
  const classNames = getClassNames({
    size,
    underline,
    italic,
    weight,
    color,
    fontFamily,
    initialClassName: 'Base',
  })

  return React.createElement(
    tag,
    {
      ...rest,
      className:
        classNames.map((element) => styles[element]).join(' ') +
        ' ' +
        rest.className,
    },
    children,
  )
}

export default Text
